import React from "react"

import "./styles.module.css"

import App from '../components/app'

const Index = () => (
  <App />
)

export default Index
